import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../../components/Modal/CustomModal";
import CustomDescriptionModal from "../../../../../components/CustomDescriptionModal";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const DeleteCustomModal = (props) => {
    const {buttonConfirm="confirm"} = props;
    const { t } = useTranslation();

    return (
        <CustomModal
            {...props}
            size="md"
            buttonConfirm={buttonConfirm}
            cancelButton={true}
            confirmButton={true}
            onConfirm={() => {
                props.onHide();
                props.onConfirm();
            }}
        >
            <div className={"row"}>
                <div className={"col-12 d-flex justify-content-center align-items-center"}>
                    <CustomDescriptionModal >
                        {props?.element_modal ?
                            <>
                                {(props?.description ? t(`${props?.description}`) : t('are_you_sure_you_want_to_delete')) + " " }
                                <b>{props?.data?.length + " "+t(props?.element_modal).toLowerCase()}</b>?
                            </>:
                            <>
                                {t(`${props?.description}`)}
                            </>
                        }
                    </CustomDescriptionModal>
                </div>
            </div>

        </CustomModal>
    );
};

export default DeleteCustomModal;
